import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as instructorActions from '../../_actions/roster.actions'
// import 'antd/lib/popover/style/index.css'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css'
import './reporting.css'
import _ from 'lodash'
import { Dialog } from 'primereact/dialog'
import WeeklyReport from './WeeklyReport'
import DailyReport from './DailyReport'
import LeaveReport from './LeaveReport'
import OverviewReport from './OverviewReport'

// import SelectComponent from '../common/SelectComponent'
import { Select } from 'antd'
import DraggableModalDialog from '../common/DraggableModalDialog'

import { reports } from './constants'
import DownloadModal from './DownloadModal'

const REPORT_TYPES = [
    {
        label: 'Summary Report',
        value: 'summary',
    },
    {
        label: 'Weekly Report',
        value: 'weekly',
    },
    // {
    //     label: 'Daily Report',
    //     value: 'daily',
    // },
    {
        label: 'Leave Report',
        value: 'leave',
    },
]

class Reporting extends Component {
    state = {
        currentMonth: new Date(),
        selectedDate: new Date(),
        showModal: false,
        event: {},
        events: [],
        employees: [],
        displayEvents: [],
        displayEmployees: [],
        show: false,
        activeTab: 'weekly',
        selectedBranch: {},
        selectedDepartment: {},
        selectedReport: '',
        show: false,
    }

    componentDidMount() {
        this.setState({ mounted: true })
    }

    toggle = tab => {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab,
            })
        }
    }

    handleChange = option => {
        this.setState({ selectedReport: option })
    }

    handleModalShow = () => {
        this.setState({ show: true })
    }

    handleClose = () => {
        this.setState({ show: false })
    }

    render() {
        const report_view = this.state.selectedReport
        return (
            <div className="">
                <div className="row">
                    <div className="panel">
                        <div className="panel-heading">
                            <h3 className="panel-title">Reporting View</h3>
                        </div>
                        <div className="panel-body">
                            <div className="container-fluid">
                                <div>
                                    <h4>Select Report</h4>
                                    <div className="row">
                                        <div className="col-sm-3 reportToolBar">
                                            <Select
                                                options={REPORT_TYPES}
                                                name="reportTypes"
                                                onChange={this.handleChange}
                                                // className="reportTypeCss"
                                                placeholder="Select a Report"
                                                style={{ width: '100%' }}
                                            />
                                        </div>
                                        <div className="col-sm-3">
                                            <button
                                                type="submit"
                                                className="btn btn-success btn-md-w"
                                                onClick={this.handleModalShow}
                                            >
                                                Export
                                            </button>
                                            <Dialog
                                                header="Export Report"
                                                visible={this.state.show}
                                                // footer={renderFooter('displayBasic')}
                                                onHide={this.handleClose}
                                                maximized={false}
                                                maximizable={true}
                                                resizable={true}
                                                breakpoints={{
                                                    '960px': '75vw',
                                                    '640px': '100vw',
                                                }}
                                                style={{ width: '50vw' }}
                                            >
                                                <DownloadModal
                                                    onHide={this.handleClose}
                                                ></DownloadModal>
                                            </Dialog>
                                            {/* <Modal
                                                dialogComponentClass={
                                                    DraggableModalDialog
                                                }
                                                dialogClassName="mod-w450"
                                                show={this.state.show}
                                                onHide={this.handleClose}
                                                animation={true}
                                            >
                                                <Modal.Header closeButton>
                                                    <Modal.Title>
                                                        Download Report
                                                    </Modal.Title>
                                                </Modal.Header>
                                                <DownloadModal></DownloadModal>
                                            </Modal> */}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="panel">
                                                <div className="panel-body">
                                                    {report_view ===
                                                        reports.SUMMARY && (
                                                        <OverviewReport />
                                                    )}
                                                    {report_view ===
                                                        reports.WEEKLY && (
                                                        <WeeklyReport />
                                                    )}
                                                    {report_view ===
                                                        reports.DAILY && (
                                                        <DailyReport />
                                                    )}
                                                    {report_view ===
                                                        reports.LEAVE && (
                                                        <LeaveReport />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        events: state.roster.events,
        displayWorkEvents: state.roster.displayAbsenceEvents,
        employees: state.roster.employeeList,
        selectedEmployee: state.roster.selectedEmployee,
        branches: state.BranchReducer.branchList,
        departments: state.DepartmentReducer.departmentList,
        actionTypes: state.ActionTypesReducer.actionTypes,
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(instructorActions, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(Reporting)
